import React, { useState } from 'react'
import { Helmet } from 'react-helmet'

import { Hero } from './Hero'
import { Services } from './Services'
import { SuccessStories } from './SuccessStories'
import { Testimonials } from './Testimonials'
import { MeetOurTeam } from './MeetOurTeam'
import { KnowOurSecrets } from './KnowOurSecrets'
import { useTranslations } from 'src/provider/LocaleProvider'
import { CustomModal } from 'src/components/common/Modal/CustomModal'
import ChildrenModal from 'src/components/common/ChildrenModal'
import Congratulations from 'src/assets/logos/congratulations.avif'
import Error from 'src/assets/logos/error.avif'

export function Home() {
    const [congratulations, setCongratulations] = useState<boolean>(false)
    const t = useTranslations()
    const [error, setError] = useState<boolean>(false)
    const [emailError, setEmailError] = useState<boolean>(false)
    const handleCongratulations = () => {
        setCongratulations(!congratulations)
    }
    const handleError = () => {
        setError(!error)
    }
    const handleEmailError = () => {
        setEmailError(!emailError)
    }
    return (
        <>
            {congratulations && (
                <CustomModal
                    handleClose={handleCongratulations}
                    content={
                        <ChildrenModal
                            handleClose={handleCongratulations}
                            image={Congratulations}
                            title={t('bookACall.modal.title')}
                            content={t('bookACall.modal.content')}
                            button={t('cta.close')}
                            double={true}
                        />
                    }
                />
            )}
            {error && (
                <CustomModal
                    handleClose={handleError}
                    content={
                        <ChildrenModal
                            handleClose={handleError}
                            image={Error}
                            title={t('bookACall.error.title')}
                            content={t('bookACall.error.content')}
                            button={t('cta.close')}
                            contact={'Support'}
                            double={false}
                        />
                    }
                />
            )}
            {emailError && (
                <CustomModal
                    handleClose={handleEmailError}
                    content={
                        <ChildrenModal
                            handleClose={handleEmailError}
                            image={Error}
                            title={t('bookACall.error.ops')}
                            content={t('bookACall.error.email')}
                            button={t('cta.close')}
                            contact={'Support'}
                            double={false}
                        />
                    }
                />
            )}
            <Helmet>
                <title>{t('home.helmet.title') ?? ''}</title>
                <meta
                    name="description"
                    content={t('home.helmet.description') ?? ''}
                />
                <meta name="keywords" content={t('home.helmet.keywords') ?? ''} />

                {/* Open Graph (para compartir en redes) */}
                <meta property="og:title" content={t('home.helmet.titleOG') ?? ''} />
                <meta property="og:description" content={t('home.helmet.descriptionOG') ?? ''} />
                <meta property="og:image" content="https://blureffect.co/assets/preview.jpg" />
                <meta property="og:url" content="https://blureffect.co" />
                <meta property="og:type" content="website" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Blur Effect" />
                <meta name="twitter:description" content={t('home.helmet.descriptionTwitter') ?? ''} />
                <meta name="twitter:image" content="https://blureffect.co/assets/preview.jpg" />
            </Helmet>
            <Hero
                setCongratulations={handleCongratulations}
                setError={handleError}
                setEmailError={handleEmailError}
            />
            <Services />
            <SuccessStories />
            <Testimonials />
            <MeetOurTeam />
            <KnowOurSecrets />
        </>
    )
}
